// extracted by mini-css-extract-plugin
module.exports = {"accordions":"ReturnMethodsInfoContainer_accordions__AX8wF","pageWrap":"ReturnMethodsInfoContainer_pageWrap__hKbvg"};